import React from 'react'
import { useTranslation } from 'react-i18next'

import { Navbar as NavbarCr, NavbarGroup } from '@creditas/navbar'
import { Typography } from '@creditas/typography'
import { Action, Av } from '@creditas/icons'
import { styled, css } from '@creditas/stylitas'

import { destroyCredentials } from 'services/localStorage/authentication'
import { SearchInput } from 'components/SearchInput'
import { SurpriseAction } from 'components/SurpriseAction'

import LogoCreditas from 'components/Navbar/LogoCreditas.tsx'
import { ROUTES } from 'pages'
import { config } from 'config'

const Button = styled.button`
  border: none;
  margin: 0;
  padding: 0;
  width: auto;
  overflow: visible;
  background: transparent;
  color: inherit;
  font: inherit;
  line-height: normal;
`

const Container = styled.div`
  ${props =>
    !props.useNewNavbar &&
    css`
      justify-content: space-between;
    `}
  display: flex;
  width: 1150px;
  margin: auto;
`

const handleLogout = () => {
  destroyCredentials()
  window.location.replace('/sign-in')
}

const Navbar = ({ useNewNavbar = false }) => {
  const { t } = useTranslation(['common'])

  return (
    <NavbarCr>
      <Container useNewNavbar={useNewNavbar}>
        <NavbarGroup>
          <a href="/">
            <LogoCreditas />
          </a>
        </NavbarGroup>
        {useNewNavbar ? (
          <NavbarGroup style={{ width: 725, marginLeft: 40 }}>
            <SearchInput small />
          </NavbarGroup>
        ) : (
          <NavbarGroup style={{ paddingRight: 110 }} links>
            <a href={ROUTES.SURPRISE} style={{ textDecoration: 'none' }}>
              <Typography color="#FFFFFF">
                {t('navigation.my-assignments')}
              </Typography>
            </a>
            <a
              href={config.externalUrls.communication}
              style={{ textDecoration: 'none' }}
            >
              <Typography color="#FFFFFF">
                {t('navigation.communication')}
              </Typography>
            </a>
          </NavbarGroup>
        )}
        <NavbarGroup>
          {useNewNavbar && (
            <>
              <SurpriseAction small />
              <a
                aria-label={t('navigation.search')}
                style={{ textDecoration: 'none' }}
                href="https://atendimento.creditas.com/minhas-ligacoes"
              >
                <Av.Headphones color="#FFFFFF" />
              </a>
            </>
          )}

          <Button
            aria-label={t('navigation.search')}
            style={{ textDecoration: 'none' }}
            onClick={handleLogout}
          >
            <Action.LogOut color="#FFFFFF" />
          </Button>
        </NavbarGroup>
      </Container>
    </NavbarCr>
  )
}

export { Navbar }
